export default "__VITE_ASSET__ab154d4d__"